import { storage } from "../utils/storage";

//for local.
// const APIUrl = "https://localhost:63946/api/";
// const authUrl = "https://localhost:7015/api/";

//for server side
const APIUrl = "https://radarapi.ailtra.app/api/";
const authUrl = "https://radarauth.ailtra.app/api/";
const WebSocketUrl = "";

export const auth0AudienceId = "https://dev-gu4rza3y0kjyasbc.us.auth0.com/api/v2/";
export const auth0Domain = "dev-gu4rza3y0kjyasbc.us.auth0.com";
export const auth0ClientId = "r1MvFap4q0R41P6vSIRFiHJJtSRgnZd9";
export const auth0ClientSecret = "pWQiVFn2jaW-aQaG7v_I8PHo8j1R4azJd6elp-DoJHX7R49O4Abm4zyo-pwFUaYs";

export const discordApiUrl = "https://discord.com/api/"
export const discordClientId = "1338366624646037525";
export const discordClientSecret = "ZXgVBxXDTDeLPkmNvD1qHcT6ofAU0OQa";
export const discordRedirectUri = "https://radar.ailtra.app";
//export const discordRedirectUri = "http://localhost:3000";
export const discordPort = 53134;
export const discordBotPermissions = 2147592224;

export const guestUserId = "15a6399f-03cc-45a6-a559-475545535400";
export const guestUserName = "Guest User";  

export function apiUrl(endpoint: string): string {
    let url = `${APIUrl}${endpoint}`;
    return url;
}

export function authApiUrl(endpoint: string): string {
    let url = `${authUrl}${endpoint}`;
    return url;
}

type Headers = {
    'Content-Type': string;
    Authorization?: string;
    refreshToken?: string;
};

export async function post(url: string, data: any, withToken: boolean = true, isAuth: boolean = false): Promise<any> {
    const headers: Headers = {
        'Content-Type': 'application/json',
    };
    if (withToken) {
        headers.Authorization = `Bearer ${storage.getToken()}`;
    }
    let endpointUrl;
    if (isAuth) {
        endpointUrl = authApiUrl(url);
    } else {
        endpointUrl = apiUrl(url);
    }
    return fetch(endpointUrl, {
        method: 'POST',
        headers,
        body: JSON.stringify(data),
    }).then((response) => response.json());
}

export async function patch(url: string, data: any, withToken: boolean = true, isAuth: boolean = false): Promise<any> {
    const headers: Headers = {
        'Content-Type': 'application/json',
    };
    if (withToken) {
        headers.Authorization = `Bearer ${storage.getToken()}`;
    }
    let endpointUrl;
    if (isAuth) {
        endpointUrl = authApiUrl(url);
    } else {
        endpointUrl = apiUrl(url);
    }
    return fetch(endpointUrl, {
        method: 'PATCH',
        headers,
        body: JSON.stringify(data),
    }).then((response) => response.json());
}

export async function put(url: string, data: any, withToken: boolean = true, isAuth: boolean = false): Promise<any> {
    const headers: Headers = {
        'Content-Type': 'application/json',
    };
    if (withToken) {
        headers.Authorization = `Bearer ${storage.getToken()}`;
    }
    let endpointUrl;
    if (isAuth) {
        endpointUrl = authApiUrl(url);
    } else {
        endpointUrl = apiUrl(url);
    }
    return fetch(endpointUrl, {
        method: 'PUT',
        headers,
        body: JSON.stringify(data),
    }).then((response) => response.json());
}

export async function get(url: string, withToken: boolean = true, isAuth: boolean = false): Promise<any> {
    const headers: Headers = {
        'Content-Type': 'application/json',
    };
    if (withToken) {
        headers.Authorization = `Bearer ${storage.getToken()}`;
    }
    let endpointUrl;
    if (isAuth) {
        endpointUrl = authApiUrl(url);
    } else {
        endpointUrl = apiUrl(url);
    }
    return fetch(endpointUrl, {
        method: 'GET',
        headers,
    }).then((response) => response.json());
};

export function webSocketUrl(endpoint: string): string {
    let url = `${WebSocketUrl}${endpoint}`;
    return url;
}
